import { useEffect } from "react";

/**
 * Set <title>, <meta name="description">, and canonical/OG url per route.
 * Google indexes SPA content well but only sees the *initial* meta tags for
 * each URL if we update them on route mount. This keeps every page unique.
 */
export function useSEO({ title, description, path = "" } = {}) {
  useEffect(() => {
    const base = "https://7figurecleaner.com.au";
    const canonical = `${base}${path || ""}`;

    if (title) document.title = title;

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", canonical);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);

    // Update canonical link
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);
  }, [title, description, path]);
}
